export const DEFAULT_REFERRER = 'console.pro.primary';
export const FIELD_SERVICE_2021_REFERRER = 'console.pro.field_service_2021';